// import { inject } from '@angular/core';
// import { CanActivateFn } from '@angular/router';
// import { AuthService } from '../services/auth.service';
// import { CookieService } from 'ngx-cookie-service';
// import { TOKEN } from '../keys/key';
// import { firstValueFrom } from 'rxjs';

// export const authGuard: CanActivateFn = async (route, state) => {
//   // return true
//   //? Inyección de dependencias
//   const auth = inject(AuthService);
//   const cookies = inject(CookieService);
//   //* Obtenemos el token
//   const token = cookies.get(TOKEN);
//   //! Si no existe
//   if (!token) return restrict(auth);
//   //? Verificamos el token con la API y procedemos en función de la respuesta
//   const isValidToken = await validateToken(auth, token);
//   return isValidToken ? true : restrict(auth);
// };

// /** @description Valida el token llamando al servicio de autenticación. */
// const validateToken = async (auth: AuthService, token: string) => {
//   try {
//     //? Consultamos a nuestra API Rest
//     return await firstValueFrom(auth.checkToken(token));
//   } catch (err: any) {
//     //! En caso de error, consideramos el token como inválido
//     throw err;
//   }
// };

// /** @description Pasamos el servicio, deslogeamos y retornamos false para detener la propagación de la ruta */
// const restrict = (auth: AuthService) => {
//   auth.logout().subscribe();
//   return false;
// };

import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { CookieService } from 'ngx-cookie-service';
import { firstValueFrom } from 'rxjs';

import { AuthService } from '../services/auth.service';
import { TOKEN, REFRESH_TOKEN } from '../keys/key';

export const authGuard: CanActivateFn = async () => {
  const auth = inject(AuthService);
  const cookies = inject(CookieService);
  const router = inject(Router);

  const token = cookies.get(TOKEN);

  // Si tenemos access token, verificamos su validez.
  if (token) {
    try {
      const isValid = await auth.checkToken(token);

      if (isValid) {
        return true;
      }
    } catch {
      // El token puede haber vencido o ser inválido.
      // Intentamos renovar más abajo.
    }
  }

  // Si no hay access token válido, intentamos renovarlo.
  if (cookies.get(REFRESH_TOKEN)) {
    try {
      await firstValueFrom(auth.refreshToken());
      return true;
    } catch {
      // Si falla la renovación, la sesión no puede recuperarse.
    }
  }

  // No quedan credenciales válidas.
  auth.forceLogout();

  return router.createUrlTree(['/ingresar']);
};
